import React from 'react'
import { Button, Typography, theme } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faXmark } from '@fortawesome/free-solid-svg-icons'

const { Text } = Typography

const GenAITabs = ({ tabs, activeTabId, onTabChange, onAddTab, onCloseTab, onTabTitleChange }) => {
  const { token } = theme.useToken()

  const handleAddTabClick = () => {
    onAddTab()
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#f5f5f5',
        borderBottom: `1px solid ${token.colorBorder}`,
        padding: '0 8px',
        minHeight: '48px'
      }}
    >
      {/* Tab List and Add Button Container */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {tabs.map((tab) => (
          <div
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: activeTabId === tab.id ? 'white' : 'transparent',
              border: activeTabId === tab.id ? `1px solid ${token.colorBorder}` : '1px solid transparent',
              borderBottom: activeTabId === tab.id ? '1px solid white' : `1px solid ${token.colorBorder}`,
              borderRadius: '8px 8px 0 0',
              padding: '8px 12px',
              margin: '0 2px',
              cursor: 'pointer',
              maxWidth: '200px',
              minWidth: '120px',
              position: 'relative',
              marginBottom: '-1px'
            }}
          >
            <Text
              ellipsis={{ tooltip: tab.title }}
              style={{
                flex: 1,
                fontSize: '13px',
                fontWeight: 'bold',
                color: activeTabId === tab.id ? token.colorText : token.colorTextSecondary
              }}
            >
              {tab.title}
            </Text>

            {tabs.length > 1 && (
              <Button
                type='text'
                size='small'
                icon={<FontAwesomeIcon icon={faXmark} style={{ fontSize: '10px' }} />}
                onClick={(e) => {
                  e.stopPropagation()
                  onCloseTab(tab.id)
                }}
                style={{
                  minWidth: '16px',
                  width: '16px',
                  height: '16px',
                  marginLeft: '4px',
                  padding: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              />
            )}
          </div>
        ))}

        {/* Add Tab Button - immediately after tabs */}
        <Button
          type='text'
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={handleAddTabClick}
          style={{
            minWidth: '32px',
            width: '32px',
            height: '32px',
            margin: '0 4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: `1px solid ${token.colorBorder}`,
            backgroundColor: '#e6f7ff', // Light blue background
            borderRadius: '4px'
          }}
        />
      </div>
    </div>
  )
}

export default GenAITabs
